import "./App.css";
import DefaultLayout from "./crm/components/defaultLayout";
import { Route, Routes } from "react-router-dom";
import Login from "./crm/views/Login";
import PrivateRoute from "./crm/routes/PrivateRoute";
import { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import getPublicIP from "./crm/utils/getPublicIp";
import { setIP } from "./crm/store/slices/IPSlice";
import Loader from "./crm/components/atoms/Loader";
import { vendorStoresThunk } from "./crm/store/thunks/vendorStoreThunk";

function App() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.token);

  useEffect(() => {
    if (token) {
      dispatch(vendorStoresThunk());
    }
    const fetchIP = async () => {
      const ip = await getPublicIP();
      dispatch(setIP(ip));
    };
    fetchIP();
  }, [dispatch, token]);

  const loading = <Loader />;
  return (
    <div className="App">
      <Suspense fallback={loading}>
        <Routes>
          <Route path="/signIn" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/*" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
